var React = require('react');

function EditLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M34.636 3.465a1 1 0 011.414 0l8.486 8.486a1 1 0 010 1.414l-30.1 30.1a1 1 0 01-1.415 0L4.537 34.98a1 1 0 010-1.415l30.1-30.1zm.707 2.122L6.658 34.273l7.07 7.07 28.686-28.685-7.07-7.071z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.012 33.299a1 1 0 01.937.266l8.486 8.486a1 1 0 01-.39 1.656l-12.73 4.242A1 1 0 01.05 46.684l4.242-12.728a1 1 0 01.72-.657zm.667 2.824L2.581 45.42l9.296-3.098-6.198-6.198zm31.78-32.651l-.7.7 7.069 7.07.7-.7a5 5 0 00-7.07-7.07zm-1.396-1.433a7 7 0 019.898 9.898l-.012.012-1.414 1.414a1 1 0 01-1.414 0L34.637 4.88a1 1 0 010-1.414l1.414-1.414.012-.012z","key":1})]);
}

EditLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = EditLight;

EditLight.default = EditLight;
